
import React, { useEffect, useMemo, useState } from 'react';
import { prepareHistoricalVolatilityData } from "../utils";
import { Row, Col, Card, Typography, Divider } from 'antd';
import Slide from "../../../Components/Slide";
import StockChart from "../../../charts/StockChart";




const getDateRange = ({items})=>{
    let startDate = items[0].chart[0][0];
    let endDate = items[0].chart[items[0].chart.length-1][0];
    return {startDate, endDate};

}


const HistoricalVolatility = ({ items, itemColors }) => {
    const [windowSize, setWindowSize] = useState(60);
    const [returnsData, setReturnsData] = useState([]);
    const [volatilityData, setVolatilityData] = useState([]);
    const [rollingVolatility, setRollingVolatility] = useState([]);
    const [selectedRange, setSelectedRange] = useState({
        startDate: null,
        endDate: null
    });
    const validRange = useMemo(()=>getDateRange({items}), [items]);

    useEffect(() => {
        if (items.length) {
            const {volatilitySeries, amplifiedSeries, rollingVolatilitySeries} = prepareHistoricalVolatilityData(items, itemColors, windowSize);
            const dateKws = {startDate: selectedRange.startDate, endDate: selectedRange.endDate};
            setReturnsData(amplifiedSeries);
            setVolatilityData(volatilitySeries);
            setRollingVolatility(rollingVolatilitySeries);
        }
    }, [items, itemColors, windowSize, selectedRange]);


    return (
        <Card
            bordered={false}
            className={'pb-6 mb-6'}
            title={<Typography.Title level={4}>Rolling 60 Day Volatility Windows With Performance</Typography.Title>}
            extra={
            <Row gutter={[32, 32]}>
                <Slide onChange={setWindowSize}
                       value={windowSize}
                       min={5}
                       max={90}
                       tooltip={'Adjust the Window Size of the Chart'}
                       postfix={' Days'}
                />
            </Row>
            }
        >
            <StockChart
                height={700}
                dataSeries={[
                    {
                        plot: 0,
                        data: volatilityData,
                        disableScrollerChart: true,
                        format: '%',
                        legend: {postfix: '%', precision: 2, format: '%'},
                        yScale: 'percent',
                        yMinorGrid: false
                    },
                    {
                        plot: 1,
                        data: rollingVolatility,

                    }
                ]}
            />
            <Divider/>


        </Card>
    );
};

export default HistoricalVolatility;